function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "JgiLTpLYUVYqJAJq8M0ssa",
  cx: 32,
  cy: 32,
  r: 33.002,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "reflect"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#efdcb1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2e0bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.011,
  stopColor: "#f2e0bc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.362,
  stopColor: "#f9edd2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.699,
  stopColor: "#fef4df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff7e4"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#JgiLTpLYUVYqJAJq8M0ssa)",
  d: "M55.454,45.668c0.5,0.898,1.504,1.337,2.532,1.332c1.75-0.008,3.153,1.483,3.002,3.262 C60.855,51.838,59.434,53,57.852,53L48,53v1H26h-8H7c-1.71,0-3.086-1.431-2.996-3.161C4.089,49.216,5.545,48,7.17,48L8,48 c1.215,0,2.176-1.083,1.973-2.336C9.813,44.681,8.889,44,7.893,44L3,44c-1.71,0-3.086-1.431-2.996-3.161 C0.089,39.216,1.545,38,3.17,38l6.33,0c1.381,0,2.5-1.119,2.5-2.5v0c0-1.381-1.119-2.5-2.5-2.5h0C8.119,33,7,31.881,7,30.5v0 C7,29.119,8.119,28,9.5,28H18v-7h-7.5c-1.995,0-3.601-1.67-3.495-3.688C7.104,15.419,8.803,14,10.698,14L18,14v-4h24h6h8.5 c1.995,0,3.601,1.67,3.495,3.688C59.896,15.581,58.197,17,56.302,17L53.5,17c-1.995,0-3.601,1.67-3.495,3.688 C50.104,22.581,51.803,24,53.698,24L56,24c1.777,0,3.194,1.546,2.978,3.366c-0.179,1.509-1.546,2.572-3.064,2.635 c-1.197,0.05-2.122,1.153-1.874,2.406C54.228,33.355,55.123,34,56.089,34H60.5c1.995,0,3.601,1.67,3.495,3.688 C63.896,39.581,62.197,41,60.302,41L58,41C55.808,41,54.166,43.35,55.454,45.668z M2.5,33L2.5,33C3.881,33,5,31.881,5,30.5v0 C5,29.119,3.881,28,2.5,28h0C1.119,28,0,29.119,0,30.5v0C0,31.881,1.119,33,2.5,33z M2.5,33L2.5,33C3.881,33,5,31.881,5,30.5v0 C5,29.119,3.881,28,2.5,28h0C1.119,28,0,29.119,0,30.5v0C0,31.881,1.119,33,2.5,33z"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "JgiLTpLYUVYqJAJq8M0ssb",
  x1: 33,
  x2: 33,
  y1: 58,
  y2: 6,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "reflect"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#41bfec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.232,
  stopColor: "#4cc5ef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.644,
  stopColor: "#6bd4f6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8ae4fd"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#JgiLTpLYUVYqJAJq8M0ssb)",
  d: "M50,58H16c-1.657,0-3-1.343-3-3V9c0-1.657,1.343-3,3-3h20.757 c0.796,0,1.559,0.316,2.121,0.879l13.243,13.243C52.684,20.684,53,21.447,53,22.243V55C53,56.657,51.657,58,50,58z"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "JgiLTpLYUVYqJAJq8M0ssc",
  x1: 38.879,
  x2: 46.454,
  y1: 20.121,
  y2: 12.546,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "reflect"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c6effd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#b7ecfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#95e6fd"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#JgiLTpLYUVYqJAJq8M0ssc)",
  d: "M52.121,20.122L38.878,6.879c-0.255-0.255-0.556-0.452-0.878-0.6V18c0,1.657,1.343,3,3,3 h11.721C52.574,20.678,52.377,20.377,52.121,20.122z"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "JgiLTpLYUVYqJAJq8M0ssd",
  x1: 45.5,
  x2: 45.5,
  y1: 24.083,
  y2: 18.083,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "reflect"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#42c6ee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#3bc3ed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2ebeea"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#JgiLTpLYUVYqJAJq8M0ssd)",
  d: "M41,21c-1.657,0-3-1.343-3-3v3c0,1.657,1.343,3,3,3h12v-1.757 c0-0.434-0.102-0.855-0.279-1.243H41z"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "JgiLTpLYUVYqJAJq8M0sse",
  x1: 22,
  x2: 22,
  y1: 21,
  y2: 6,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "reflect"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#81dcf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#8ce1f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9ee8fd"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#JgiLTpLYUVYqJAJq8M0sse)",
  d: "M21.5,21H13V9c0-1.657,1.343-3,3-3h9.5C26.881,6,28,7.119,28,8.5v0 c0,1.381-1.119,2.5-2.5,2.5h-5c-1.381,0-2.5,1.119-2.5,2.5v0c0,1.381,1.119,2.5,2.5,2.5h1c1.381,0,2.5,1.119,2.5,2.5v0 C24,19.881,22.881,21,21.5,21z M29,17c-1.105,0-2,0.895-2,2s0.895,2,2,2c1.105,0,2-0.895,2-2S30.105,17,29,17z"
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "JgiLTpLYUVYqJAJq8M0ssf",
  x1: 41.5,
  x2: 41.5,
  y1: 41,
  y2: 58,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "reflect"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#47c3ee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#32b5e8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#32b5e8"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#JgiLTpLYUVYqJAJq8M0ssf)",
  d: "M44,41l9,0v14c0,1.657-1.343,3-3,3H33c-1.657,0-3-1.343-3-3v0c0-1.657,1.343-3,3-3l11.5,0 c1.381,0,2.5-1.119,2.5-2.5v0c0-1.381-1.119-2.5-2.5-2.5H44c-1.657,0-3-1.343-3-3v0C41,42.343,42.343,41,44,41z M36,41 c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S37.657,41,36,41z"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f1b0fdb.svg";
export { ForwardRef as ReactComponent };